/* eslint-disable no-nested-ternary */
import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { DISCONTINUED } from '@mummssoftware/utils/constants';
import {
  formatDateMMDDYY,
  YYYYMMDDtoMMDDYY,
} from '@mummssoftware/utils/formatters';
import {
  getCreatePersonCredential,
  getModUserCredential,
} from '@mummssoftware/mumms-print/PDFComponents/CarePlanProblems/utils';
import { CPPContext } from '../Context/CPPContext';
import {
  ReadOnlyTaskDiv,
  ReadTaskTextDiv,
  ReadTask,
  TaskText,
  DCTaskText,
  InfoDateTaskDiv,
} from '../../components/layout/WrapperDiv';
import { Context } from '../../context';
import { Other } from '../CPPEngine/constants';
import defaults from '../../translations/en.json';

type ReadOnlySingleTaskPlannerProps = {
  task: mumms.PatientCppTask;
};

export const ReadOnlySingleTaskPlanner = ({
  task,
}: ReadOnlySingleTaskPlannerProps) => {
  const intl = useIntl();
  const isDC = task.status === DISCONTINUED;
  const { previewMode } = useContext(CPPContext);
  const { currentUser } = useContext(Context);

  const displayDCDate = previewMode
    ? formatDateMMDDYY(new Date())
    : formatDateMMDDYY(task.statusdatetime);

  const displayDCName = previewMode
    ? `${currentUser.firstName} ${currentUser.lastName}`
    : getModUserCredential(task);

  const displayEffDate = task.effectivedate
    ? YYYYMMDDtoMMDDYY(task.effectivedate)
    : task.createdatetime
    ? YYYYMMDDtoMMDDYY(task.createdatetime)
    : '';

  const displayEffName = previewMode
    ? `${currentUser.firstName} ${currentUser.lastName}`
    : getCreatePersonCredential(task);

  const taskText =
    task.tasktext && task.tasktext === Other && task.userprovideddisplayname
      ? task.userprovideddisplayname
      : task.tasktext;

  return (
    <ReadOnlyTaskDiv id="read-only-task-div">
      <ReadTask>
        <TaskText>
          <ReadTaskTextDiv>{`${task.who} ${taskText} ${task.frequency} ${task.period}`}</ReadTaskTextDiv>
          <InfoDateTaskDiv id="task-info">
            <DCTaskText fixed>
              {intl.formatMessage(defaults.startTaskDate, {
                user: displayEffName,
                date: displayEffDate,
              })}
            </DCTaskText>
            {isDC && (
              <DCTaskText>
                {intl.formatMessage(defaults.stopTaskDate, {
                  user: displayDCName,
                  date: displayDCDate,
                })}
              </DCTaskText>
            )}
          </InfoDateTaskDiv>
        </TaskText>
      </ReadTask>
    </ReadOnlyTaskDiv>
  );
};
